import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MatDialogContent,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { CookieConsentService } from 'src/app/services/cookie-consent.service';

@Component({
  selector: 'app-cookie-popup',
  templateUrl: './cookie-popup.component.html',
  styleUrl: './cookie-popup.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatButtonModule, MatDialogModule],
})
export class CookiePopupComponent {
  showPolicy = false;
  hasDeclined = false;

  constructor(
    private dialogRef: MatDialogRef<CookiePopupComponent>,
    private cookieService: CookieConsentService
  ) {}

  accept(): void {
    this.cookieService.saveConsent();
    this.dialogRef.close();
  }

  decline(): void {
    // Ne ferme pas le popup : on affiche le message de refus
    this.hasDeclined = true;
  }

  showPrivacyPolicy(event: Event): void {
    event.preventDefault();
    this.showPolicy = true;
  }

  hidePrivacyPolicy(): void {
    this.showPolicy = false;
  }
}
